// An intake signup the owner has not reviewed yet: the same test
// GET /api/customers/intake-signups makes, on a row from GET /api/customers.
// Parent rows only; a property is reviewed with its signup.
export const isUnreviewedSignup = (customer) => Boolean(customer)
  && customer.from_intake_form === true
  && !customer.intake_reviewed_at
  && customer.parent_customer_id == null;

// The "New - From Form" badge. While the size is unconfirmed the Size
// unconfirmed badge holds the row alone, so the two never show together.
export const showsNewSignupBadge = (customer) => isUnreviewedSignup(customer)
  && !customer.size_confirmation_pending;

// Unreviewed signups first, everything else in the order it arrived. Stable,
// so held signups (already at the top) and the server's order are kept within
// each group. Returns a new array.
export const newSignupsFirst = (customers) => customers
  .map((customer, index) => ({ customer, index, isNew: isUnreviewedSignup(customer) }))
  .sort((a, b) => (a.isNew === b.isNew ? a.index - b.index : a.isNew ? -1 : 1))
  .map(({ customer }) => customer);
